import { useEffect } from 'react';

import { VERTICAL_URL } from 'settings';

type ChangePaymentMethodTokenPayload = {
  extra?: {
    contract_id?: number | string | null;
  } | null;
};

const DEFAULT_SUBSCRIPTIONS_URL = `${VERTICAL_URL}/subscriptions/me`;

function decodeBase64Url(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);

  return atob(`${base64}${padding}`);
}

function decodeTokenPayload(token: string): ChangePaymentMethodTokenPayload | null {
  try {
    const [, payload] = token.split('.');

    if (!payload) {
      return null;
    }

    return JSON.parse(decodeBase64Url(payload)) as ChangePaymentMethodTokenPayload;
  } catch {
    return null;
  }
}

function getRedirectUrl(search: string): string {
  const query = new URLSearchParams(search);
  const token = query.get('token');

  if (!token) {
    return DEFAULT_SUBSCRIPTIONS_URL;
  }

  const payload = decodeTokenPayload(token);
  const subscriptionId = payload?.extra?.contract_id;

  if (!subscriptionId) {
    return DEFAULT_SUBSCRIPTIONS_URL;
  }

  return `${VERTICAL_URL}/subscriptions/${subscriptionId}/me`;
}

const ChangePaymentMethod = (): null => {
  useEffect(() => {
    window.location.replace(getRedirectUrl(window.location.search));
  }, []);

  return null;
};

export default ChangePaymentMethod;
